{
  "title": "Guiding Bolt",
  "source": "Player's Handbook",
  "levelAndSchool": "1st-level evocation",
  "level": 1,
  "castingTime": "1 action",
  "range": "120 feet",
  "components": "V, S",
  "duration": "1 round",
  "description": [
    "A flash of light streaks toward a creature of your choice within range. Make a ranged spell attack against the target. On a hit, the target takes 4d6 radiant damage, and the next attack roll made against this target before the end of your next turn has advantage, thanks to the mystical dim light glittering on the target until then.",
    "At Higher Levels. When you cast this spell using a spell slot of 2nd level or higher, the damage increases by 1d6 for each slot level above 1st."
  ],
  "spellLists": ["cleric"]
}
